module.exports = __webpack_public_path__ + "media/packs/images/flags/MV-4a535e5dc80fb853318b0ad3b3949fc1.svg";